<template lang="pug">
  SspLayout.recalls(area="tnt")
    template(slot="actions")
      router-link.btn.btn-primary(:to="{ name: 'recallCreate' }")
        i.fa.fa-undo
        span.ml5 Recall
    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th ID
        th Entity
        th Recaller
        th Status
        th Type
        th Created
        th
      tr(v-for="r in recalls")
        td {{r.id}}
        td
          router-link(:to="{name: 'order', params: {id: r.orderId}}" v-if="r.orderId") {{r.orderId}}
          router-link.kzcode-default(:to="{name: 'dissectorWithCode', params: {code: r.recallCodes[0]}}" v-if="r.recallCodes && r.recallCodes[0]") {{r.recallCodes[0]}}
          a(@click="goToSection(r.sectionId)" v-if="r.sectionId") {{r.sectionId}}
        td
          span(v-if="r.recaller") {{r.recaller.username}}
        td {{r.status}}
        td {{r.type}}
        td {{r.timestamp | date}}
        td.actions
          router-link.btn-view(title="View recall" :to="{name: 'recall', params: { id: r.id }}") View
</template>

<script>
import TrackNTrace from '@/service/apis/TrackNTrace'
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    recalls: null
  }),
  methods: {
    fetchData(page) {
      const req = page.pageRequest()
      return TrackNTrace.listRecalls(req)
        .then((resp) => {
          this.recalls = resp.data.content
          return resp.data.totalElements
        })
    },
    goToSection(sectionId) {
      Core.getSection(sectionId)
        .then((resp) => {
          this.$router.push({ name: 'section', params: { orderId: resp.data.orderId, sectionId } })
        })
    }
  },
  components: {
    DataGrid
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/configuration/recall/Recalls.vue